import styled from "styled-components";
import { SimpleChipItem } from "@similarweb/ui-components";
import { SWReactIcons } from "@similarweb/icons";

export const StyledCardFilterSimpleChip = styled(SimpleChipItem)`
    ${SWReactIcons} {
        width: 10px;
        height: 5px;

        svg {
            width: 10px;
            height: 5px;
        }
    }
`;
